export enum PatternVisualisationType {
  COLOR = 'COLOR',
  IMAGE = 'IMAGE',
  PATTERN = 'PATTERN',
  DRAWING = 'DRAWING',
  MANCHON = 'MANCHON'
}
